import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker, { DatePickerProps } from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UISelect from 'components/selectbox/UISelect';
import CommonUtil from 'utils/CommonUtil';
import BooleanUtil from "utils/BooleanUtil";
import UIUtils from "utils/UIUtils";
import codeDataStore from "common/codedata/store/CodeDataStore";
import message from "common/message/source/MessageSource";
function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	
	//초기 데이터 설정
	let totalCnt:number = 0;

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 3,
				//"PageLength": 20,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0"
				
			},
			Def:{
				Row:{
				//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
			{"Header": "No","Name": "SEQ","Width": "90"}
			],
			"Cols": [
				{"Header": "No","Type": "Int", "Name": "SEQ","Align": "Center","RelWidth": 0.5,"CanEdit": "0"},
				{"Header": "코드","Type": "Text","Name": "HELP_CD","RelWidth": 0.5,"Align": "Center","CanEdit": "0"},
				{"Header": "코드명","Type": "Text","Name": "HELP_NM","RelWidth": 1,"Align": "Left","CanEdit": "0"},
				{"Header": "도움말","Type": "Lines","Name": "HELP_CONT","MinWidth": 250,"Align": "Left","CanEdit": 1,"RelWidth": 1},
				{"Header": "등록자" ,"Type": "Text","Name": "REG_USER_NM","RelWidth": 0.5,"Align": "Center","CanEdit": 0},
				{"Header": "등록일","Type": "Text","Name": "REG_DATE","RelWidth": 0.5,"Align": "Center","CanEdit": "0", Format: "yyyy-MM-dd", DataFormat: "yyyy-MM-dd HH:mm:ss"}
			    ]
				
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				doSearch();
			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				
		    },	

			

			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;
		
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
				_data = JSON.stringify(d.slice(0, 20), null, 2);
				_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
				_data = JSON.stringify(d, null, 2);
				}
				
			}
			
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//조회 데이터
		'data':[]
	}
	
	//====== 그리드 공통 부  END
	

    
    //====== 그리드 데이터 가지고 오기  START
    async function doSearch() {
		let param = {};

		//파라미터 전송
		const response:any = await CommonUtil.execute({
		 	 url:'adm_6510_select',
             data: param
        })
				
		//전체데이터 
		let result = response.LIST;

		if(result != null){
			//전체ROW개수 
			totalCnt = Object.keys(result).length;
			setTotalRowCnt(Object.keys(result).length);
		}
        
		//데이터 처리
        ib.data = result;
	  	// @ts-ignore	
		sheet.loadSearchData(result);  //data 로딩 처리 
		// @ts-ignore	
		sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		// @ts-ignore	
		//makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화
        
    }
    
    //====== 그리드 데이터 가지고 오기  END

	
	//리스트에 변경내용 저장
	async function codeSave (){
		
		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
		
			let addItems: {HELP_CD:string; HELP_NM:string;HELP_CONT:string }[] = [];
			
			// @ts-ignore
			let addItem: { HELP_CD:string; HELP_NM:string;HELP_CONT:string } = {};

			// @ts-ignore
			var rows = sheet.getDataRows();
			for (var i = 0; i < rows.length; i++) {	
				if ( rows[i]["Changed"] !== undefined && rows[i]["Changed"]  === 1  ){
					
					// @ts-ignore
					addItem = {
						HELP_CD: rows[i]["HELP_CD"],
						HELP_NM: rows[i]["HELP_NM"],
						HELP_CONT: rows[i]["HELP_CONT"]
					};
					addItems.push(addItem);
				}
			}

			let param = {
				"HELP_CD_LIST":addItems
			}

			console.log(JSON.stringify(param));

			const response:any = await CommonUtil.execute({
				url:'adm_6510_update',
				data: param
		   }).catch((error: {COMMON_HEAD:any}) => {
				CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
				return false;
			});

			
			if (response) {
				await UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
				doSearch();
			}

		}
	}

	// init 
	React.useEffect(() => {
	
		//ib시트 생성
		ib.create();
		
		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);		  
		}
	},[])

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">풍선도움말</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">풍선도움말</h1>
						<div className="tb-top">
							<div>
								<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
							</div>
							<div className="hz-root hz-gap5">
								<Button color="pri-o" size="sm" onClick={codeSave}>저장</Button>
							</div>
						</div>
						<div id='sheetDiv'>[D] IBSHEET 영역</div>

					</main>

				</div>
		</PageContainer>
	);
}
export default ContentsContainer;